import { createAction, createReducer } from '@reduxjs/toolkit';
import UtmTracking from 'types/UtmTracking';

const firstVisitTrackingReceived = createAction<UtmTracking>('firstVisitTracking/received');

const firstVisitTrackingReducer = createReducer({}, (builder) => {
  builder.addCase(firstVisitTrackingReceived, (_state, action) => {
    return action.payload;
  });
});

export { firstVisitTrackingReducer, firstVisitTrackingReceived };
